import { useAuth } from "context/AuthContext"

export enum ACCESS_COMPONENTS {
  TERMINAL = "terminal",
  METRIC = "metric",
  PROJECT = "project",
  MARKET_SECTOR = "market-sector",
  FINACIAL_STATEMENT = "financial-statement",
  DATASETS = "datasets",
  STUDIO = "studio",
}
export enum ACCESS_ACTIONS {
  VIEW = "view",
  DOWNLOAD = "download",
  ZOOM_MAX = "max",
  PRESET_SAVE = "save",
  CREATE_CHART = "create_chart",
}

export function useAccess(
  component: `${ACCESS_COMPONENTS}`,
  action: `${ACCESS_ACTIONS}`
): boolean | null {
  const auth = useAuth()

  if (action === ACCESS_ACTIONS.VIEW) {
    return true
  }

  if (!auth.isLoginFinished) {
    return null
  }

  if (action === ACCESS_ACTIONS.ZOOM_MAX) {
    return auth.isLoggedIn
  }

  if (action === ACCESS_ACTIONS.DOWNLOAD) {
    return auth.user.isPaid()
  }

  if (action === ACCESS_ACTIONS.PRESET_SAVE) {
    return auth.isLoggedIn
  }

  if (action === ACCESS_ACTIONS.CREATE_CHART) {
    return auth.user.isPaid()
  }

  return true
}
